import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Provider } from '../../../api-clients/oem-connection';

/**
 * Counter banner for unresolved oem_unlinked_events (SRA003-116). Dumb
 * component — receives count + provider, emits mapClicked when the
 * contractor clicks through. Hidden when count is zero or when the
 * contractor dismisses for the session (next page load brings it back if
 * count is still > 0, per HANDOFF §9 Q2).
 */
@Component({
  selector: 'app-unmapped-events-banner',
  templateUrl: './unmapped-events-banner.component.html',
  styleUrls: ['./unmapped-events-banner.component.css'],
  standalone: false,
})
export class UnmappedEventsBannerComponent {
  @Input() count = 0;
  @Input() provider!: Provider;
  @Input() providerLabel = '';
  @Output() mapClicked = new EventEmitter<Provider>();

  dismissed = false;

  get visible(): boolean {
    return this.count > 0 && !this.dismissed;
  }

  onMap(): void {
    this.mapClicked.emit(this.provider);
  }

  dismiss(): void {
    this.dismissed = true;
  }
}
